import {
  FETCH_SITE_ITEM,
  SET_SITE_ITEM
} from './actions.js'

const DEFAULT = {
  siteItem: null // This will be the response from GET /project or GET /contact depending on the urlParam pds_type
}

/**
 * Reducer for siteitem item.
 */
export function siteitem (state = DEFAULT, action) { // eslint-disable-line
  switch (action.type) {
    case FETCH_SITE_ITEM: {
      return Object.assign({}, state, {
        siteItem: action.siteItem
      })
    }
    case SET_SITE_ITEM: {
      return Object.assign({}, state, {
        siteItem: action.siteItem
      })
    }
    default:
      return state
  }
}
